import * as types from './types';

const initialState = {
  loading: false,
  mensajeError: null,
  list: [],
  totalItems: 0,
  filterParams: {},
  trackingOriginal: null,
  loadingTrackingOriginal: false,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case types.GET_LOG_MODIFICACIONES_START:
      return {
        ...state,
        error: null,
        loading: true,
      };
    case types.GET_LOG_MODIFICACIONES_SUCCESS:
      return {
        ...state,
        list: payload,
        loading: false,
      };
    case types.GET_LOG_MODIFICACIONES_ERROR:
      return {
        ...state,
        error: payload,
        loading: false,
      };

    case types.SET_FILTER_PARAMS:
      return {
        ...state,
        filterParams: payload,
      };
    case types.RESET_LOG_MODIFICACIONES_STATE:
      return {
        ...initialState,
      };

    case types.GET_TRACKING_ORIGINAL_START:
      return {
        ...state,
        loadingTrackingOriginal: true,
      };
    case types.GET_TRACKING_ORIGINAL_SUCCESS:
      return {
        ...state,
        trackingOriginal: payload,
        loadingTrackingOriginal: false,
      };
    case types.GET_TRACKING_ORIGINAL_ERROR:
      return {
        ...state,
        error: payload,
        loadingTrackingOriginal: false,
      };
    default:
      return state;
  }
  
};
